import ResetPassword from "@/components/auth/reset-password";
import withErrorBoundary from "@/components/hoc/with-error-boundary";
import { getRoutes } from "@/utils/helpers";
import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";

const ResetPasswordPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const routes = getRoutes();

  if (!searchParams.get("token")) {
    return <Navigate to={routes.signIn} replace />;
  }

  return <ResetPassword />;
};

export default withErrorBoundary({ component: "ResetPasswordPage" })(
  ResetPasswordPage
);
